import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from './13.png'
import { Menu, X, Gift } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-white/80 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src={logo} 
              alt="Oceanique Logo" 
              className="h-32 w-auto object-contain" 
            />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/before-after">Before & After</NavLink>
            <NavLink to="/contact">Contact</NavLink>
            <a
              href="https://app.squareup.com/gift/MLT2WMJ6SJGPG/order"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-yellow-500 to-amber-500 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105 hover:from-yellow-600 hover:to-amber-600 flex items-center gap-2"
            >
              <Gift className="w-4 h-4" />
              Gift Cards
            </a>
            <Link
              to="/booking"
              className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-3 rounded-full text-sm font-semibold hover:shadow-lg transition-all duration-300 hover:scale-105 hover:from-blue-700 hover:to-cyan-700 flex items-center gap-2"
            >
              Book Now
            </Link>
          </div>
          
          <div className="md:hidden mr-2">
            <button 
              onClick={toggleMenu} 
              className="text-gray-900 hover:text-blue-600 p-2 rounded-lg hover:bg-blue-50 transition-colors"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <MobileNavLink to="/" onClick={toggleMenu}>Home</MobileNavLink>
            <MobileNavLink to="/about" onClick={toggleMenu}>About</MobileNavLink>
            <MobileNavLink to="/services" onClick={toggleMenu}>Services</MobileNavLink>
            <MobileNavLink to="/before-after" onClick={toggleMenu}>Before & After</MobileNavLink>
            <MobileNavLink to="/contact" onClick={toggleMenu}>Contact</MobileNavLink>
            <a
              href="https://app.squareup.com/gift/MLT2WMJ6SJGPG/order"
              target="_blank"
              rel="noopener noreferrer"
              onClick={toggleMenu}
              className="flex items-center justify-center gap-2 bg-gradient-to-r from-yellow-500 to-amber-500 text-white px-3 py-3 rounded-full text-base font-semibold hover:shadow-lg transition-all duration-300 hover:from-yellow-600 hover:to-amber-600 mx-3 mt-3"
            >
              <Gift className="w-5 h-5" />
              Gift Cards
            </a>
            <Link
              to="/booking"
              onClick={toggleMenu}
              className="block text-center bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-3 py-3 rounded-full text-base font-semibold hover:shadow-lg transition-all duration-300 hover:from-blue-700 hover:to-cyan-700 mx-3 mt-3"
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

const NavLink = ({ to, children }) => (
  <Link 
    to={to} 
    className="text-gray-800 inline-flex items-center px-1 pt-1 text-sm font-medium hover:text-blue-600 transition-all duration-300 ease-in-out border-b-2 border-transparent hover:border-blue-400 relative group"
  >
    {children}
    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-600 to-cyan-600 group-hover:w-full transition-all duration-300"></span>
  </Link>
);

const MobileNavLink = ({ to, children, onClick }) => (
  <Link 
    to={to} 
    onClick={onClick}
    className="text-gray-800 block px-3 py-2 text-base font-medium hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
  >
    {children}
  </Link>
);

export default Navbar;